import { TrackJS } from "trackjs";
import { JwtHelper } from "@/helpers/utilities/JwtHelper";

const networkMessagesToBeIgnored = () => {
  return [
    /^404 : GET https:\/\/graph\.microsoft\.com\/(\bv1\.0\b|\bbeta\b)\/users\/.*\/photos\/48x48\/\$value$/,
    /^404 : GET https:\/\/graph\.microsoft\.com\/(\bv1\.0\b|\bbeta\b)\/groups\/.*\/owners/, // https://regex101.com/r/SAUAkN/1
    /^404 : GET https:\/\/graph\.microsoft\.com\/(\bv1\.0\b|\bbeta\b)\/groups\/.*\/members/,
    /^400 : GET https:\/\/skobostats.azurewebsites.net\/api\/CustomerAdminUsers/,
    /^403 : GET https:\/\/.*\.sharepoint.com\/.*\/_api\/web\/sitegroups\/GetByName\(.*\)\/users/ // https://regex101.com/r/n3GrFi/1
  ];
};

const promiseMessagesToBeIgnored = () => {
  return [/^Avoided redundant navigation to current location: "\/".$/gm];
};

export default {
  initialize() {
    if (import.meta.env.VITE_APP_DO_TRACK_ERRORS === "true") {
      TrackJS.install({
        token: "9df19a659fd14a02b69d32e31af6111e",
        application: import.meta.env.VITE_APP_TRACKJS_APPLICATION,
        console: { display: import.meta.env.DEV },
        version: import.meta.env.VITE_APP_VERSION,
        onError: function (payload) {
          if (payload && payload.entry === "ajax") {
            if (networkMessagesToBeIgnored().some(rx => rx.test(payload.message))) {
              return false;
            }
          } else if (payload && payload.entry === "promise") {
            if (promiseMessagesToBeIgnored().some(rx => rx.test(payload.message))) {
              return false;
            }
          }

          return true;
        }
      });
    }
  },

  // Vue 3: errorHandler is per-app config, not a global Vue.config
  installVueErrorHandler(app) {
    if (import.meta.env.VITE_APP_DO_TRACK_ERRORS !== "true") {
      return;
    }

    app.config.errorHandler = (err, vm, info) => {
      // Vue 3 exposes props on $props (vm.$props or vm.$.props)
      if (vm && vm.$props && Object.keys(vm.$props).length > 0) {
        // eslint-disable-next-line no-console
        console.log("Props passed to component", vm.$props);
      }

      var infoMessage = `Error in component: <${vm && vm.$options ? vm.$options.name : "unknown"} />\n`;
      if (info) {
        infoMessage += `Error occurred during lifecycle hook: ${info}\n`;
      }

      // eslint-disable-next-line no-console
      console.log(infoMessage);

      TrackJS.track(err);
    };
  },

  setUserFromJwt(token) {
    if (import.meta.env.VITE_APP_DO_TRACK_ERRORS === "true") {
      const userId = JwtHelper.getCustomerId(token) + "/" + JwtHelper.getUserId(token);

      TrackJS.configure({
        userId
      });
    }
  },

  registerError(e, additionalInfo) {
    if (import.meta.env.PROD) {
      if (!window.TrackJS) {
        return;
      }

      TrackJS.console.log(additionalInfo);
      TrackJS.track(e);
    }
  },

  registerMessage(m) {
    if (import.meta.env.PROD) {
      TrackJS.track(m);
    }
  },

  networkMessagesToBeIgnored,
  promiseMessagesToBeIgnored
};
